const state = {
  loginLog: {
    City: null, // 登录所在城市（需要请求用户授权获取手机定位）
    Province: null, // 登录所在省份（需要请求用户授权获取手机定位）
    Country: null, // 登录所在国家（需要请求用户授权获取手机定位）
    Language: null, // 浏览的语言风格
    ThirdAppType: 1, // 第三方登录凭证类型（剧汇王朝用户登录时为空） = ['微信小程序' = 1, '其他' = 999], 使用数值，避免变更名称后出错
    SourceType: '小程序', // 登陆渠道 = ['Web', '小程序', 'App', '微信公众号', '其它']
    DeviceType: 'CellPhone', // 登录设备类型 = ['PC', 'Pad', 'CellPhone']
    Sysetm: null, // 客户机系统类型
    SysVersion: null, // 客户机系统版本
    Platform: 'WeChat', // 产品寄宿的平台
    PFMVersion: null, // 产品寄宿的平台的版本
    ProductVersion: '0.0.1.1' // 产品版本与POMS版本一样
  },
  systemInfo: null,
  iyanyiUser: {
    UserId: undefined
  },
  userInfo: null,
  likeType:''
}

const mutations = {
  changeLoginLog: (state, log) => {
    state.loginLog = log
  },
  changeSystemInfo: (state, log) => {
    state.systemInfo = log
  },
  changeIyanyiUser: (state, log) => {
    state.iyanyiUser = log
  },
  changeUserInfo: (state, log) => {
    state.userInfo = log
  },
  changeLikeType: (state, log) => {
    state.likeType = log
  }
}

const actions = {
  changeLoginLog ({ commit }, log) {
    commit('changeLoginLog', log)
  },
  changeSystemInfo ({ commit }, log) {
    commit('changeSystemInfo', log)
  },
  changeIyanyiUser ({ commit }, log) {
    commit('changeIyanyiUser', log)
  },
  changeUserInfo ({ commit }, log) {
    commit('changeUserInfo', log)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
